import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeOrderDiscountModal, orderDiscountAdd } from '../actions/index';
import { Modal } from 'react-bootstrap';

class ModalOrderDiscount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      discountAmount: 0,
    }
  }

  componentWillMount() {
    if (this.props.current_order.discount > 0) {
      this.setState({ discountAmount: this.props.current_order.discount });
    }
  }

  handleDiscountChange = discount => {
    this.setState({ discountAmount: discount });
  }

  handleAddDiscount = () => {
    this.props.orderDiscountAdd(this.state.discountAmount);
    this.props.closeOrderDiscountModal();
  }

  render() {
    return (
      <Modal show={this.props.modals.showOrderDiscountModal} onHide={this.props.closeOrderDiscountModal}>
        <Modal.Header closeButton>
          <Modal.Title>Enter Discount Percentage</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="center-text">
            <div>
              <span className="h1 text-center">{this.state.discountAmount}%</span>
            </div>
            <br />
            <div>
              <button type="button" onClick={event => this.handleDiscountChange(0)} className="btn btn-lg btn-primary mt-1">0%</button>
              &nbsp;
              <button type="button" onClick={event => this.handleDiscountChange(10)} className="btn btn-lg btn-primary mt-1">10%</button>
              &nbsp;
              <button type="button" onClick={event => this.handleDiscountChange(25)} className="btn btn-lg btn-primary mt-1">25%</button>
              &nbsp;
              <button type="button" onClick={event => this.handleDiscountChange(50)} className="btn btn-lg btn-primary mt-1">50%</button>
              &nbsp;
              <button type="button" onClick={event => this.handleDiscountChange(100)} className="btn btn-lg btn-primary mt-1">100%</button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={this.props.closeOrderDiscountModal}>Close</button>&nbsp;
          <button type="button" className="btn btn-primary" onClick={this.handleAddDiscount}>Save Changes</button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps({ modals, current_order }) {
  return { modals, current_order };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { closeOrderDiscountModal, orderDiscountAdd }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalOrderDiscount);



// WEBPACK FOOTER //
// ./src/containers/modal_order_discount.js